import { BlinqLogo } from '@components/BlinqAssets';

import { FOOTER_COLUMNS, LOGIN_HREF, SOCIAL_LINKS } from './content';
import { FortuneCookie } from './FortuneCookie';
import { LandingButton } from './LandingButton';
import * as styles from './LandingFooter.css';

interface LandingFooterProps {
  claimHref: string;
  ctaLabel: string;
  onClaimClick?: () => void;
}

export const LandingFooter = ({ claimHref, ctaLabel, onClaimClick }: LandingFooterProps) => (
  <footer className={styles.footer}>
    <div className={styles.inner}>
      <div className={styles.top}>
        <div className={styles.actions}>
          <div className={styles.buttons}>
            <LandingButton href={claimHref} tone="dark" size="compact" onClick={onClaimClick}>
              {ctaLabel}
            </LandingButton>
            <LandingButton href={LOGIN_HREF} tone="outline" size="compact">
              Login
            </LandingButton>
          </div>
          <FortuneCookie />
        </div>
        <nav className={styles.columns} aria-label="Footer">
          {FOOTER_COLUMNS.map((column) => (
            <div key={column.title} className={styles.column}>
              <h2 className={styles.columnTitle}>{column.title}</h2>
              <ul className={styles.links}>
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a className={styles.link} href={link.href} target="_blank" rel="noreferrer">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </div>
      <div className={styles.bottom}>
        <BlinqLogo className={styles.wordmark} />
        <div className={styles.meta}>
          <ul className={styles.social}>
            {SOCIAL_LINKS.map((social) => (
              <li key={social.label}>
                <a
                  className={styles.socialLink}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`Blinq on ${social.label}`}
                >
                  <img className={styles.socialIcon} src={social.icon} alt="" />
                </a>
              </li>
            ))}
          </ul>
          <p className={styles.copyright}>
            US patent pending. © {new Date().getFullYear()} Blinq Technologies Pty Ltd.
          </p>
        </div>
      </div>
    </div>
  </footer>
);
